<script lang="ts">
      import { browser } from '$app/environment'
      import { createScrollBlockContext, createHeaderVisiblityContext } from '$lib/ui/menu/index.svelte'
      import { onMount, tick } from 'svelte'

      function toggleScroll(state: boolean) {
            if (state == false) return flip(() => body.classList.remove('no-scroll'))
            return flip(() => body.classList.add('no-scroll'))
      }

      async function flip(fn: Function) {
            const start = body.getBoundingClientRect()
            fn()
            await tick()

            const end = body.getBoundingClientRect()

            const diff = end.width - start.width

            const fixed = [...body.querySelectorAll('.fixed-element'), body] as HTMLElement[]

            fixed.forEach((f) => {
                  if (diff > 0) f.style.width = `calc(100% - ${diff}px)`
                  else f.style.width = ''
            })

            const fake = [...body.querySelectorAll('.fake-margin'), body] as HTMLElement[]

            fake.forEach((f) => {
                  if (diff > 0) f.style.width = `${diff}px`
                  else f.style.width = ''
            })
      }

      const ui = createHeaderVisiblityContext()
      const sb = createScrollBlockContext()

      let body: HTMLElement
      let html: HTMLElement

      if (browser) {
            body = document.body
            html = document.documentElement
      }

      let { children = null } = $props()

      $effect(() => {
            toggleScroll(sb.bodyScrollBlocked)
      })
</script>

<div class="fake-margin fixed right-0 h-full bg-[#4b4b4be6] z-[10000]"></div>
{@render children?.()}
